import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import { parseOODateTime } from "./pureFunctions";
import { useConfig } from "./ConfigContext";
export default function FototerminErstellung({
   selectedTimeSlot,
   setSelectedTimeSlot,
   terminData,
   setTerminData,
   createAppointments,
   objData,
   getRoute,ownerId
}) {

   const config=useConfig()
   
   function abbrechen() {
      setSelectedTimeSlot(false);
   }

   /* {
      data: {
         description: "Besichtigungstermin",
         start_dt: "2020-08-01 17:45:00",
         end_dt: "2020-08-01 18:00:00",
         art: "Besichtigung",
         ganztags: false,
         note: "Das ist eine Notiz",
         private: false,
         ressources: ["Konferenzraum", "Firmenfahrzeug"],
      },
      relatedAddressIds: [1935],
      relatedEstateId: 608,
      location: {
         estate: 608,
      },
      subscribers: {
         users: [14],
      },
   }; */
   return (
      <>
         {selectedTimeSlot && (
            <Modal show={selectedTimeSlot} size="xl" onHide={abbrechen}>
               <Modal.Header closeButton>
                  <Modal.Title>
                     Zeitslot {selectedTimeSlot.start.toLocaleString()} bis {selectedTimeSlot.end.toLocaleTimeString()}
                  </Modal.Title>
               </Modal.Header>
               <Modal.Body>
                  <h5>Gebuchte Leistungen:</h5>
                  <ul>
                     {terminData.fotos === "Ja" && <li>Fotos</li>}
                     {terminData.luftaufnahmen === "Ja" && <li>Luftaufnahmen</li>}
                     {terminData.ogulo === "Ja" && <li>Ogulo</li>}
                     {terminData.matterport === "Ja" && <li>Matterport</li>}
                  </ul>
                  <hr />
                  <div className="mb-3">
                     Gesamtdauer:{" "}
                     <strong>
                        {Math.round(
                           selectedTimeSlot.distanceAfter + selectedTimeSlot.distanceBefore + terminData.duration
                        )}
                     </strong>{" "}
                     Minuten.{" "}
                     <small>
                        (Davon: Termin: <strong>{Math.round(terminData.duration)}</strong> min, Hinfahrt:{" "}
                        <strong>{Math.round(selectedTimeSlot.distanceBefore)}</strong> min Rückfahrt:{" "}
                        <strong>{Math.round(selectedTimeSlot.distanceAfter)}</strong> min)
                     </small>{" "}
                  </div>
                  <Form>
                     <Row>
                        <Form.Group as={Col} className="mb-3" controlId="zusatzinfos">
                           <Form.Label>Zusatzinfos</Form.Label>
                           <Form.Control
                              autoComplete="off"
                              placeholder=""
                              as="textarea"
                              onChange={(e) => setTerminData((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
                              name="zusatzinfos"
                              value={terminData.zusatzinfos}
                           />
                        </Form.Group>
                     </Row>
                     <Row>
                        <Form.Group as={Col} controlId={"starttime"} className="mb-3">
                           <Form.Label>Startzeit des Termins vor Ort</Form.Label>
                           <DatePicker
                              isClearable
                              selected={terminData.starttime}
                              onChange={(e) =>
                                 setTerminData((prev) => ({
                                    ...prev,
                                    ["starttime"]: e,
                                    endtime: new Date(e.getTime() + terminData.duration * 60000),
                                 }))
                              }
                              className={"bootstrap-datepicker"}
                              calendarClassName="custom-date-calendar"
                              dateFormat="dd.MM.yyyy HH:mm"
                              popperPlacement="bottom"
                              showTimeSelect
                              timeIntervals={5}
                              showTimeSelectOnly
                              showTimeCaption={false}
                              minTime={selectedTimeSlot.start.getTime() + selectedTimeSlot.distanceBefore * 60000}
                              maxTime={
                                 selectedTimeSlot.end.getTime() -
                                 (selectedTimeSlot.distanceAfter + terminData.duration) * 60000
                              }
                              locale="de"
                           />
                        </Form.Group>
                        <Form.Group as={Col} controlId={"endtime"} className="mb-3">
                           <Form.Label>Endzeit (wird automatisch eingestellt)</Form.Label>
                           <DatePicker
                              disabled
                              selected={terminData.endtime}
                              // onChange={(e) => setoOTermin((prev) => ({ ...prev, ["endtime"]: e }))}
                              className={"bootstrap-datepicker disabled"}
                              calendarClassName="custom-date-calendar"
                              dateFormat="HH:mm"
                              popperPlacement="bottom"
                              showTimeSelect
                              timeIntervals={5}
                              showTimeSelectOnly
                              showTimeCaption={false}
                              locale="de"
                           />
                        </Form.Group>
                     </Row>
                  </Form>
               </Modal.Body>
               <Modal.Footer>
                  <Button variant="secondary" onClick={abbrechen}>
                     Abbrechen
                  </Button>
                  <Button
                     variant="primary"
                     onClick={() => {
                        createAppointments({
                           data: {
                              description: "FT " + objData[config.estate.objektBezeichnung],
                              start_dt: parseOODateTime(terminData.starttime),
                              end_dt: parseOODateTime(terminData.endtime),
                              art: "Fototermin",
                              ganztags: false,
                              allowTransitTime: true,
                              transitTime:
                                 Math.floor(selectedTimeSlot.distanceAfter / 60)
                                    .toString()
                                    .padStart(2, "0") +
                                 ":" +
                                 (selectedTimeSlot.distanceAfter % 60).toString().padStart(2, "0") +
                                 ":00",
                              transitTimePre:
                                 Math.floor(selectedTimeSlot.distanceBefore / 60)
                                    .toString()
                                    .padStart(2, "0") +
                                 ":" +
                                 (selectedTimeSlot.distanceBefore % 60).toString().padStart(2, "0") +
                                 ":00",
                              note: `\
                              Leistungen:\
                              \n${terminData.fotos === "Ja" && " Fotos"}\
                              ${terminData.luftaufnahmen === "Ja" ? " Luftaufnahmen" : ""}\
                              ${terminData.ogulo === "Ja" ? " Ogulo" : ""}\
                              ${terminData.matterport === "Ja" ? " Matterport" : ""}\
                              \n\nZustand:\
                              ${terminData.ordnungszustand}\
                              \n\n${terminData.zusatzinfos}\
                              \n\n${terminData.flexibel === "Ja" ? "Zeitraum flexibel" : ""}\
                              `,

                              private: false,
                           },
                           relatedAddressIds: [ownerId],
                           relatedEstateId: objData.id,
                           location: {
                              estate: objData.id,
                           },
                           subscribers: {
                              users: [terminData.zustandigkeit],
                           },
                        });
                     }}
                  >
                     Termin eintragen
                  </Button>
               </Modal.Footer>
            </Modal>
         )}
      </>
   );
}
